import { notificationApis } from '@apis/notificationApis';
import { useQuery } from '@hooks/useQuery';

export const useNotifcationUnreadCount = () => {
  return useQuery(['/notification/unread-count/'], () =>
    notificationApis.get('/notification/unread-count/', {}).then((r) => r[200]!.unread_count),
  );
};
